export default __webpack_public_path__ + "static/media/flying-rocket.bb258579.svg";